module.exports = __webpack_public_path__ + "static/media/REDS-Logo.60577ea8.png";